import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NativeAppService } from 'app/@core/backend/common/services/native-app.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { UserStore } from 'app/@core/stores/user.store';

@Component({
  selector: 'ngx-nativeapp-advert',
  templateUrl: './nativeapp-advert.component.html',
  styleUrls: ['./nativeapp-advert.component.scss']
})
export class NativeappAdvertComponent implements OnInit {

  public displayInstallFromStoreLink = false;

  constructor(
    private nativeAppService: NativeAppService,
    private deviceService: DeviceDetectorService,
    private userStore: UserStore,
    private router: Router,
    private sanitizer: DomSanitizer

  ) { }

  ngOnInit(): void {
  }


  showMobileAppAdvert() {

    if (this.nativeAppService.isFromApp()) return false;
    /*
    // DEBUG MODE TEMPS // Demo Client On Apple Review Account.
    if (this.router.url.indexOf('2740cf86-13d0-40a9-bd96-33490a80a845') > 0) {
      return true;
    }
    return false;
    // DEBUG MODE TEMPS*/

    if (this.deviceService.isDesktop()) return false;
    return true;
  }

  getMobileLink() {
    return this.sanitizer.bypassSecurityTrustUrl("trainerfriendapp://" + window.location.href);
  }

  getStoreLink(): string {
    if (this.deviceService.os.toLowerCase() === "android") {
      if(this.userStore.settings().playStoreUrl && this.userStore.settings().playStoreUrl.length > 10) return this.userStore.settings().playStoreUrl;
      return "https://play.google.com/store/apps/details?id=com.TrainerFriend.TrainerFriendClientApp";
    } else {
      if(this.userStore.settings().appStoreUrl && this.userStore.settings().appStoreUrl.length > 10) return this.userStore.settings().appStoreUrl;
      return "https://apps.apple.com/us/app/id1614640437";
    }
  }


  displayInstallFromStore(): void {
    setTimeout(() => {
      this.displayInstallFromStoreLink = true;
    }, 2000);
  }


}
